import { reactive } from "vue";
import { t, serverUrl } from "./entity-model";

const baseUrl = serverUrl + "nessie/rest/assessment/";

function UserModel() {
  this.users = null;
  this.user = null;
  this.status = null;
}

UserModel.prototype.register = function(emailAddress, password) {
  fetch(baseUrl + "users", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ emailAddress, password })
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": POST " + response.url);
    }
  }).catch(error => {
    console.log(error);
  });
}

UserModel.prototype.login = function(emailAddress = null, password = null) {
  if (emailAddress == null) {
    this.user = false;  // Explicit request to open the login screen.
    this.status = null;
    return;
  }

  this.status = "loading";
  fetch(baseUrl + "authenticate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: emailAddress, password })
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": POST " + response.url);
    }
    response.json().then(data => {
      t.token = data.token;
      this.user = new User(emailAddress, data.token);
      this.user.loadScenarios();
      this.status = null;
    }).catch(e => console.log("Error parsing JSON."));
  }).catch(error => {
    this.status = "error";
  });
}

UserModel.prototype.logout = function() {
  t.token = null;
  this.users = null;
  this.user = null;
  this.status = null;
}

UserModel.prototype.loadUsers = function() {
  fetch(baseUrl + "users", {
    headers: { Authorization: "Bearer " + this.user.token }
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": " + response.url);
    }
    response.json().then(data => {
      this.users = data;
    }).catch(e => console.log("Error parsing JSON."));
  }).catch(error => {
    console.log(error);
  });
}

function User(emailAddress, token) {
  this.username = emailAddress.split("@")[0];
  this.emailAddress = emailAddress;
  this.token = token;
  this.scenarios = [];
}

User.prototype.loadScenarios = function() {
  fetch(baseUrl + "scenarios", {
    headers: { Authorization: "Bearer " + this.token }
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": " + response.url);
    }
    response.json().then(data => {
      this.scenarios = data;
    }).catch(e => console.log("Error parsing JSON."));
  }).catch(error => {
    console.log(error);
  });
}

User.prototype.saveScenario = function(code) {
  fetch(baseUrl + "scenarios/" + code, {
    method: "POST",
    headers: { Authorization: "Bearer " + this.token }
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": POST " + response.url);
    }
    response.json().then(data => {
      this.scenarios = data;
    }).catch(e => console.log("Error parsing JSON."));
  }).catch(error => {
    console.log(error);
  });
}

User.prototype.deleteScenario = function(code) {
  fetch(baseUrl + "scenarios/" + code, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + this.token }
  }).then(response => {
    if (!response.ok) {
      throw new Error("Status " + response.status + ": DELETE " + response.url);
    }
    response.json().then(data => {
      this.scenarios = data;
    }).catch(e => console.log("Error parsing JSON."));
  }).catch(error => {
    console.log(error);
  });
}

export const userModel = reactive(new UserModel());
